import { useState } from "react";

import styles from "./SettingsPage.module.scss";

// import { Integrations } from "../../components/AccountSettings/components/Integrations";
import { CustomValueTab } from "../../components/CustomValueTab";
import { AccountSettingsPage } from "../AccountSettingsPage";
import { ProfilePage } from "../ProfileSettingsPage";


export const SettingsPage = () => {
  const [tabValue, setTabValue] = useState("profile");
  const tabs = [
    {
      id: "tab-1",
      tab: "Profile",
      value: "profile",
      component: <ProfilePage />,
      stylesOrder: styles.fitContent
    },
    {
      id: "tab-2",
      tab: "Account",
      value: "account",
      component: <AccountSettingsPage />,
      stylesOrder: styles.fitContent
    },
    // {
    //   id: "tab-3",
    //   tab: "Integrations",
    //   value: "integrations",
    //   component: <Integrations />,
    //   stylesOrder: styles.fitContent
    // },
  ];

  const selectedTab = tabs.find((tab) => tab.value === tabValue)

  return (
    <div className={styles.root}>
      <div className={styles.titleWrapper}>
        <CustomValueTab
          tabs={tabs}
          tabValue={tabValue}
          setTabValue={setTabValue}
        />
        <div>
          {selectedTab && selectedTab.component}
        </div>
      </div>
    </div>
  );
};
